export const loadingActions = (type, flag) => ({
    type: type,
    flag: flag
});